<template lang="html">
  <Modal v-model="open" @on-cancel="open=false" :title="'Iscrizioni del socio: '+(assoc ? assoc.full_name : '')" class-name="very-large no-foot">
    <div slot="footer">
      <Button type="error" @click="open=false">
        Chiudi
      </Button>
    </div>
    <div v-if="assoc" style="position: relative">
      <div class="ivu-table spaced noborder">
        <table style="width: 100%">
          <thead>
            <tr>
              <th>Codice</th>
              <th>Data Pagamento</th>
              <th>Rilasciata il</th>
              <th>Scadenza il</th>
              <th>Tipo Tessera</th>
              <th>Quota</th>
              <th style="width: 160px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in subscriptions" :class="{ss_active: s.is_current, ss_disactive: !s.is_current}">
              <td>{{ s.number }}</td>
              <td>{{ s.payment_date && $d(Date.maintain(s.payment_date)) }}</td>
              <td>{{ $d(Date.maintain(s.date_start)) }}</td>
              <td>{{ $d(Date.maintain(s.date_end)) }}</td>
              <td>{{ s.card ? s.card.label : 'Nessuna' }}</td>
              <td>{{ $n(s.price, 'currency') }}</td>
              <td style="text-align: right">
                <Tooltip content="Stampa tessera" placement="top" v-if="s.is_current">
                  <a :href="$store.config.API_URL + '/tessera/' + s.id" target="_blank">
                    <Button type="success" size="small"  style="margin-left: 5px">
                      <Icon type="ios-pricetag"/>
                    </Button>
                  </a>
                </Tooltip>
                <Tooltip content="Stampa ricevuta" placement="top">
                  <Button v-if="s.receipt" type="success" size="small" @click="$utils.print('print-ric/'+s.receipt.id)"  style="margin-left: 5px">
                    <Icon type="ios-calculator"/>
                  </Button>
                </Tooltip>
                <Tooltip content="Stampa adesione" placement="top">
                  <Button type="info" size="small" @click="$utils.download('iscrizione-'+s.number+'.'+($store.company.module_id ? 'pdf' : 'pdf'), 'print-sub/'+s.id, {})" style="margin-left: 5px">
                    <Icon type="ios-paper"/>
                  </Button>
                </Tooltip>
                <Tooltip content="Modifica" placement="top">
                  <Button type="warning" size="small" @click="form = _.clone(s)" style="margin-left: 5px">
                    <Icon type="edit"/>
                  </Button>
                </Tooltip>
                <Tooltip content="Elimina tessera" placement="top">
                  <Button type="error" size="small" @click="del(s)" style="margin-left: 5px">
                    <Icon type="ios-trash"/>
                  </Button>
                </Tooltip>
              </td>
            </tr>
            <tr>
              <td>
                <Input v-model="form.number" placeholder="Numero tessera"/>
              </td>
              <td>
                <LocalDate v-model="form.payment_date" placeholder="Data pagamento"/>
              </td>
              <td>
                <LocalDate v-model="form.date_start" placeholder="Rilascio"/>
              </td>
              <td>
                <LocalDate v-model="form.date_end" placeholder="Scadenza"/>
              </td>
              <td>
                <Select transfer v-model="form.card_id" placeholder="Tipo Tessera" @on-change="form && selected_card && (form.price = selected_card.price)">
                  <Option v-for="c in cards" :key="c.id" :value="c.id">{{ c.label }} - {{ $n(c.price, 'currency') }}</Option>
                </Select>
              </td>
              <td>
                <NumInput v-model="form.price"/>
              </td>
              <td style="text-align: right">
                <Button type="primary" @click="save" :loading="saving" :disabled="!form.number || !form.date_start || !form.date_end || this.saving">
                  {{ form.id ? 'Salva' : 'Aggiungi' }}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Spin size="large" fix v-if="loading"/>
    </div>
  </Modal>
</template>

<script>
export default {
  props: [
    'value'
  ],
  data () {
    return {
      subscriptions: [],
      loading: true,
      saving: false,
      form: {
        number: null,
      },
      cards: [],
      next_number: null,
    }
  },
  created () {
    this.$http.get('associate-cards?company_id='+this.$store.company.id).then(res => {
      this.cards = res.data
    })
  },
  methods: {
    refresh() {
      if (!this.assoc) return null
      this.loading = true
      this.$http.get('next-subscription-number?company_id='+this.$store.company.id).then(res => {
        this.next_number = res.data
        this.$set(this.form, 'number', this.next_number)
      })
      this.$http.get('associate-subscriptions?associate_id='+this.assoc.id).then(res => {
        this.subscriptions = res.data.data
      }).finally(res => (this.loading = false))
    },
    save () {
      if (this.selected_card && this.selected_card.price != this.form.price) {
        if (!confirm('Il prezzo della tessera è stato modificato: continuare lo stesso?')) return
      }
      this.saving = true
      this.form.associate_id = this.assoc.id
      this.$http.post('associate-subscriptions', this.form).then(res => {
        if (this.form.is_current != res.data.is_current) {
          this.$emit('refresh')
        }
        this.form = {}
        this.refresh()
      }).finally(res => (this.saving = false))
    },
    del(s) {
      confirm('Sicuri di voler cancellare questa iscrizione?')
      && this.$http.delete('associate-subscriptions/'+s.id).then(() => {
        this.refresh()
        if (s.is_current) {
          this.$emit('refresh')
        }
      })
    },
  },
  watch: {
    'open' (v) {
      if (v) {
        this.subscriptions = []
        this.loading = true
        this.form = {
          payment_date: (new Date()).serializeLocal(),
          date_start: (new Date()).serializeLocal(),
        }
        this.refresh()
      }
    },
    'form.date_start': {
      immediate: true,
      handler (v) {
        if (!v) return
        var d = Date.maintain(v)
        var year = d.getFullYear();
        // var month = d.getMonth();
        // var day = d.getDate();
        var c = new Date(year, 11, 31)
        this.form.date_end = c.serializeLocal()
      }
    },
  },
  computed: {
    selected_card () {
      if (!this.form) return null
      return this.cards.find(c => c.id == this.form.card_id)
    },
    assoc () { return this.value },
    open: {
      get () {
        return !!this.value
      },
      set (v) {
        if (!v) {
          this.$emit('input', null)
        }
      }
    },
  }
}
</script>

<style lang="scss">
tr.ss_disactive td {
  background: #fee;
}
tr.ss_active td {
  background: #efe;
}
</style>
